module.exports = __webpack_public_path__ + "static/frontUserNew/img/code-weixin.4a28074a.png";